module.exports = __webpack_public_path__ + "img/fuzion-img-2.5c12524d.jpg";